import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ComponentProviderProps } from '@business/interfaces/component-provider';
import { routePaths } from '@utils/constants/routePaths';
import { getToken } from '@ports/common/sessionStateSlice';
import {
  getFirstLogin,
  getIsAuthenticated
} from '@ports/common/authStateSlice';

const authUrls = [
  '/',
  routePaths.SignUp,
  routePaths.SignIn,
  routePaths.ForgotPassword,
  routePaths.TwoFactorAuthentication
];

/*
 * This component is used redirect the user to corresponding page if user is logged in
 */
export function AuthGuard({ children }: Readonly<ComponentProviderProps>) {
  const storeToken = useSelector(getToken);
  const sessionToken = sessionStorage.getItem('token');
  const token = storeToken ? storeToken : sessionToken;

  const isAuthenticated = useSelector(getIsAuthenticated);
  const isFirstLogin = useSelector(getFirstLogin);

  useEffect(() => {
    if (
      !token &&
      !authUrls.includes(location?.pathname) &&
      !location.pathname.startsWith(routePaths.ResetPassword)
    ) {
      window.location.href = '/';
    } else if (
      token &&
      isAuthenticated &&
      authUrls.includes(location?.pathname)
    ) {
      if (isFirstLogin) {
        window.location.href = '/subscription';
      } else {
        window.location.href = '/dashboard';
      }
    }
  }, [location.pathname, token, isAuthenticated, isFirstLogin]);

  return <>{children}</>;
}
